import { createContext, useContext } from 'react'

/** When null (live storefront), inline editing is off. Editor preview provides this. */
export type PreviewInlineEditApi = {
  patch: (partial: Record<string, unknown>) => void
}

export const PreviewInlineEditContext = createContext<PreviewInlineEditApi | null>(null)

export function usePreviewInlineEdit(): PreviewInlineEditApi | null {
  return useContext(PreviewInlineEditContext)
}
